<template>
  <v-container class="pa-0" fluid>
    <KidPurchasedGiftsFilters @fetch-gifts="fetchGifts" />
    <div v-if="showEmptyGiftListSection">
      <v-row align="center" justify="center" v-if="!isGiftsFiltered">
        <v-col cols="12" md="12" class="text-center">
          <div class="body-heading-medium mb-2">No reward yet!</div>
          <div class="mb-2" v-if="isKid">
            Redeem your points for more rewards!
          </div>
        </v-col>
      </v-row>
      <v-row align="center" justify="center" v-else>
        <v-col cols="12" md="12" class="text-center">
          <div class="body-heading-medium mb-2">No Matched Reward Found!</div>
          <div>
            Apply different filters to view more rewards!
          </div>
        </v-col>
      </v-row>
    </div>

    <v-row>
      <v-col v-for="gift of gifts" :key="gift.id" cols="12" md="4">
        <KidPurchasedGiftListItem :gift="gift" :key="gift.id" />
      </v-col>
    </v-row>
    <KidPurchasedGiftsPagination @fetch-gifts="fetchGifts" />
  </v-container>
</template>

<script>
  import KidPurchasedGiftListItem from "./KidPurchasedGiftListItem";
  import KidPurchasedGiftsFilters from "./KidPurchasedGiftsFilters";
  import KidPurchasedGiftsPagination from "./KidPurchasedGiftsPagination";

  export default {
    name: "KidPurchasedGiftList",

    data() {
      return {};
    },

    computed: {
      userId() {
        return this.$route.params.id ? this.$route.params.id : this.$store.getters.userInfo.id;
      },

      isParent() {
        return this.$store.getters.userInfo.role === "parent";
      },

      isKid() {
        return this.$store.getters.userInfo.role === "child";
      },

      gifts() {
        return this.$store.getters.getGifts();
      },

      isGiftsFiltered() {
        return this.$store.getters.isGiftListFiltered();
      },

      giftFilters() {
        return this.$store.getters.getGiftListFilters();
      },

      giftListPaginationInfo() {
        return this.$store.getters.getGiftListPaginationInfo();
      },

      showEmptyGiftListSection() {
        if (this.gifts.length > 0) {
          return false;
        }
        return true;
      },
    },

    methods: {
      parsePaginationInfoToParams() {
        if (!this.$validator.isUndefined(this.giftListPaginationInfo.currentPage) && !this.$validator.isUndefined(this.giftListPaginationInfo.pageSize)) {
          let offset = (this.giftListPaginationInfo.currentPage - 1) * this.giftListPaginationInfo.pageSize;

          return `offset=${offset}&limit=${this.giftListPaginationInfo.pageSize}`;
        } else {
          return "";
        }
      },

      parseTimeRangeFilterToParams() {
        if (!this.$validator.isEmpty(this.giftFilters.timeRange.before_datetime) && !this.$validator.isEmpty(this.giftFilters.timeRange.after_datetime)) {
          return `before_datetime=${this.giftFilters.timeRange.before_datetime}&after_datetime=${this.giftFilters.timeRange.after_datetime}`;
        } else {
          return "";
        }
      },

      parseStatusFilterToParams() {
        if (!this.$validator.isEmpty(this.giftFilters.status)) {
          return `status=${this.giftFilters.status}`;
        } else {
          return "";
        }
      },

      fetchGifts() {
        this.$store.commit("setLoadingStatus", true);

        let paramsString = `${this.parseTimeRangeFilterToParams()}&${this.parseStatusFilterToParams()}&${this.parsePaginationInfoToParams()}`;

        if (this.isParent) {
          this.$http
            .get(`/children/${this.userId}/orders?${paramsString}`)
            .then((response) => {
              this.$store.commit("addGifts", response.data.orders);
              this.$store.commit("setGiftListPaginationInfo", {
                total: response.data.pagination.total,
              });
              //If "all status" filter applied, but there is no reward retrieved, that means there was no reward for this kid previously.
              if (!this.$validator.isEmpty(this.giftFilters.status) && this.giftFilters.status === "" && this.$validator.isEmpty(response.data.orders)) {
                this.$store.commit("setIsGiftListFiltered", false);
              } else {
                this.$store.commit("setIsGiftListFiltered", true);
              }
              this.$store.commit("setLoadingStatus", false);
            })
            .catch((error) => {
              console.error(error);
              this.$store.commit("setError", {
                message: "Failed to fetch rewards",
                type: "error",
              });
              this.$store.commit("setLoadingStatus", false);
            });
        } else {
          this.$http
            .get(`/orders?${paramsString}`)
            .then((response) => {
              this.$store.commit("addGifts", response.data.orders);
              this.$store.commit("setGiftListPaginationInfo", {
                total: response.data.pagination.total,
              });
              //If "all status" filter applied, but there is no reward retrieved, that means there was no reward assigned to this kid previously.
              if (!this.$validator.isEmpty(this.giftFilters.status) && this.giftFilters.status === "" && this.$validator.isEmpty(this.giftFilters.timeRange) && this.$validator.isEmpty(response.data.orders)) {
                this.$store.commit("setIsGiftListFiltered", false);
              } else {
                this.$store.commit("setIsGiftListFiltered", true);
              }
              this.$store.commit("setLoadingStatus", false);
            })
            .catch((error) => {
              console.error(error);
              this.$store.commit("setError", {
                message: "Failed to fetch rewards",
                type: "error",
              });
              this.$store.commit("setLoadingStatus", false);
            });
        }
      },
    },

    components: { KidPurchasedGiftListItem, KidPurchasedGiftsFilters, KidPurchasedGiftsPagination },

    created() {
      this.$store.commit("setGiftListFilters", {
        status: "",
        timeRange: {},
      });
      this.$store.commit("setGiftListPaginationInfo", {
        currentPage: 1,
      });
      this.fetchGifts();
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Kids/PurchasedGift/KidPurchasedGiftList.vue